<template>
  <div>
    <div class="condition-section" style="min-height: 172px">
      <div class="i-row">
        <div class="item left-section">
          <div class="i-row">
            <div class="status">{{ detail.state | status }}</div>
            <div class="i-row" style="margin-left: 21px; color: #333">
              实付金额：
              <div class="price">{{ detail.total || 0 }}</div>
              元
            </div>
          </div>
          <div style="margin-top: 20px" v-if="detail.state === 0">
            <Button
              type="primary"
              style="width: 90px; height: 45px"
              @click="onPay"
              :loading="payLoading"
              >付款</Button
            >
            <Button
              type="info"
              ghost
              style="width: 90px; height: 45px; margin-left: 10px"
              @click="onCancel"
              :loading="cancelLoading"
              >取消</Button
            >
          </div>
        </div>
        <div class="r-info">
          <div class="i-row">
            <div class="i-row">
              <div class="name">订单号</div>
              <div>{{ detail.id }}</div>
            </div>
          </div>
          <div class="i-row" style="margin-top: 20px">
            <div class="name">创建时间</div>
            <div>{{ detail.createdTime }}</div>
          </div>
          <div class="i-row" style="margin-top: 20px">
            <div class="name">付款时间</div>
            <div>{{ detail.pay }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-data">
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
      </Table>
      <div class="z-total">
        实付：
        <div style="color: #ff5c35; font-weight: Bold">
          {{ detail.total || 0 }}元
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderDetail, orderCancel } from "api/domain.js";

export default {
  name: "orderDetail",
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "待支付";
          break;
        case 1:
          title = "交易成功";
          break;
        case 2:
          title = "已取消";
          break;
        case 3:
          title = "已过期";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      detail: {
        state: 1,
      },
      domainName: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          title: "序号",
          align: "center",
          type: "index",
        },
        {
          title: "产品名称",
          align: "center",
          key: "goodsName",
        },
        {
          title: "单价",
          align: "center",
          key: "price",
          render: (h, { row }) => {
            return h("div", row.price + "元/年");
          },
        },
        {
          title: "数量",
          align: "center",
          key: "counts",
        },
        {
          title: "小计",
          align: "center",
          key: "amount",
        },
      ],
      data: [],
      tableLoading: false,
      payLoading: false,
      cancelLoading: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          orderNo: this.$route.query.id,
          // domainName: this.domainName,
          // transferStatus: this.transferStatus,
          // page: this.page,
          // limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await orderDetail(params);
        this.tableLoading = false;
        if (code === 200) {
          this.detail.amount = data.amount;
          this.detail.createdTime = data.createdTime;
          this.detail.id = data.id;
          this.detail.pay = data.pay;
          this.detail.total = data.total;
          this.detail.state = data.state;
          this.data = data.orderDetailList;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 取消订单
    async onCancel() {
      try {
        this.cancelLoading = true;
        let params = {
          orderNo: this.detail.id,
        };
        const { code, result } = await orderCancel(params);
        this.cancelLoading = false;
        if (code === 200 && result) {
          this.$Message.success("操作成功!");
        } else {
          this.$Message.warning("操作失败!");
        }
      } catch (error) {
        this.cancelLoading = false;
        console.log(error);
      }
    },
    // 付款
    onPay() {
      this.$router.push({
        path: "/shoppingCart",
        query: { id: this.detail.id },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.condition-section {
  margin: 15px;
  background-color: #fff;
  padding: 20px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
  
  .con-row {
    display: flex;
    height: 40px;
    line-height: 40px;
     margin-bottom: 20px;
    .item {
      font-size: 14px;
      font-weight: 600;
      color: #434063;
      cursor: pointer;
      margin-right: 40px;
      background: #f5f9fe;
      border-radius: 54px;
      border: 1px solid #759de6;
      width: 100px;
      text-align: center;
      line-height: 40px;
    }
    .item.active {
      color: #FFF;
      background: #315491;
    }
  }
}
.i-row.end {
  align-items: flex-end;
}
.i-row {
  display: flex;
  align-items: center;
  .name {
    min-width: 100px;
    color: #999999;
  }
}
.status {
  color: #333333;
  font-weight: bold;
  font-size: 18px;
}
.price {
  color: #ff5c35;
  font-size: 14px;
}
.left-section {
  border-right: 1px solid #f0f3f6;
  padding-right: 80px;
}
.r-info {
  margin-left: 80px;
}
.z-total {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #315491;
  }
  .ivu-table-header th,
  .ivu-table-body td {
   height: 60px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>
